<template>
  <CustomChipsGroup
    title="Necesidades Seleccionadas"
    disabled
    no-background
    no-wrap
    :object-text="keyText"
    :selected-items="value"
  />
</template>

<script>
import CustomChipsGroup from 'CustomChipsGroup';

export default {
  name: 'PlanNeeds',
  components: {
    CustomChipsGroup,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    keyText: {
      type: String,
      default: () => '',
    },
  },
};
</script>

<style lang="scss" scoped></style>
